export default __webpack_public_path__ + "static/media/edit-icon.4a597f81.svg";